import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconStarredStyle0 = cosmosIconCss;

const CosmosIconStarred$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconStarred extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '4ce25189f6a888da620de1d0834e56c1fa03ff96', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'a0b6058c8e8a792bd1dcb616dfd6125f368e3183', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '2978a7b11e94d36c466b5b305630bb423ef7a1c8', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.5 3a.5.5 0 0 0-.5.5v15.6a.4.4 0 0 0 .669.3L11 14.557l5.332 4.836A.4.4 0 0 0 17 19.1V3.5a.5.5 0 0 0-.5-.5h-11Zm10 13.614-4.16-3.778a.5.5 0 0 0-.672 0L6.5 16.614V4.5h9v12.114Zm-3.13-7.417 1.455-1.237c.208-.173.175-.335-.116-.367l-1.838-.157-.66-1.74c-.113-.261-.373-.261-.473 0l-.64 1.719-1.86.167c-.23.011-.34.2-.112.378l1.468 1.225-.527 1.771c-.083.273 0 .378.289.22l1.614-1.057 1.637 1.058c.239.157.373.052.29-.22l-.527-1.76Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconStarredStyle0; }
}, [1, "cosmos-icon-starred", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-starred"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-starred":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconStarred$1);
            }
            break;
    } });
}

const CosmosIconStarred = CosmosIconStarred$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconStarred, defineCustomElement };
